import { apiClient } from './api';
import type { CongressTradesResponse, SortDirection, SortField } from '../types/congressTrades';

export interface FetchCongressTradesParams {
  page?: number;
  perPage?: number;
  search?: string;
  sortBy?: SortField;
  sortDirection?: SortDirection;
}

interface PortalMeta {
  page: number;
  page_size: number;
  total_count: number;
  total_pages: number;
}

export const congressTradesService = {
  async fetchTrades(params: FetchCongressTradesParams = {}): Promise<CongressTradesResponse> {
    const {
      page = 1,
      perPage = 10,
      search = '',
      sortBy = 'disclosure_date',
      sortDirection = 'desc',
    } = params;

    const queryParams = new URLSearchParams({
      page: String(page),
      per_page: String(perPage),
      sort_by: sortBy,
      sort_direction: sortDirection,
    });
    if (search) queryParams.set('search', search);

    const result = await apiClient.get<{ data: CongressTradesResponse['results']; meta: PortalMeta }>(
      `/api/market-data/congress-trades/?${queryParams}`
    );

    return {
      results: result.data ?? [],
      count: result.meta.total_count,
      page: result.meta.page,
      per_page: result.meta.page_size,
      total_pages: result.meta.total_pages,
    };
  },
};
